export default {
  data () {
    return {
      CKEditorsLoading: 0
    }
  },
  methods: {
    restoreCKEditors () { // Restore all CKEDITOR instances on the page to wysiwyg mode
      return new Promise(async (resolve) => {
        let sourceEditors = 0
        if (typeof CKEDITOR !== 'undefined' && CKEDITOR && CKEDITOR.instances) {
          Object.keys(CKEDITOR.instances).forEach(async (instanceId) => {
            const editor = CKEDITOR.instances[instanceId]
            if (editor && editor.mode === 'source') {
              sourceEditors++
              try {
                editor.setMode('wysiwyg')
              } catch(e) {
                console.log(e)
              }
            }
          })
        }
        if (sourceEditors) {
          await new Promise(resolve => setTimeout(resolve, 250))
        }
        resolve()
      })
    },
    CKEditorReady () {
      this.CKEditorsLoading--
    },
    waitUntilCKEditorsLoaded () { // Since Promise.defer() is some kind of an anti-pattern, we have to use this beauriful piece of crap here to check that all CKEditors are ready
      return new Promise((resolve) => {
        let count = 0
        let interval = setInterval(() => {
          if (this.CKEditorsLoading <= 0 || count >= 200) {
            clearInterval(interval)
            resolve()
          }
          count++
        }, 50)
      })
    },
    CKEditorsReady () {
      return new Promise(async (resolve) => {
        this.CKEditorsLoading = 0
        if (typeof CKEDITOR !== 'undefined' && CKEDITOR && CKEDITOR.instances) {
          this.CKEditorPromises = []
          Object.keys(CKEDITOR.instances).forEach((instanceId) => {
            const instance = CKEDITOR.instances[instanceId]
            if (instance.status !== 'ready') {
              this.CKEditorsLoading++
            }
          })
          if (this.CKEditorsLoading) {
            await this.waitUntilCKEditorsLoaded()
          }
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}